import { render } from "./SalesReportChart.vue?vue&type=template&id=6b1a7957&ts=true"
import script from "./SalesReportChart.vue?vue&type=script&lang=ts"
export * from "./SalesReportChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__